import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Event sent when a user views the onboarding upload step',
  name: 'viewed_onboarding_upload',
};

export default META;
